import { useEffect } from "react";
import emailjs from "@emailjs/browser";

function VisitorTracker() {
  useEffect(() => {
    const sendVisitorInfo = async () => {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();

        const templateParams = {
          ip: data.ip || "N/A",
          city: data.city || "N/A",
          state: data.region || "N/A",
          country: data.country_name || "N/A",
          postal_code: data.postal || "N/A",
          timezone: data.timezone || "N/A",
          latitude: data.latitude || "N/A",
          longitude: data.longitude || "N/A",
          organization: data.org || "N/A",
          visit_time: new Date().toLocaleString(),
          page_url: window.location.href,
          browser: navigator.userAgent,
        };

        await emailjs.send(
          "YOUR_SERVICE_ID",
          "YOUR_TEMPLATE_ID",
          templateParams,
          "YOUR_PUBLIC_KEY"
        );

        console.log("Visitor information email sent successfully");
      } catch (error) {
        console.error("Error sending visitor information:", error);
      }
    };

    sendVisitorInfo();
  }, []);

  return null;
}

export default VisitorTracker;